
import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './index.css';

// Указываем русскую локализацию для всего приложения
document.documentElement.lang = 'ru';

// Находим корневой элемент
const root = document.getElementById("root");

if (root) {  
  try {
    console.log('Инициализация приложения начата...');
    
    // Полностью отключаем StrictMode, так как он вызывает двойное выполнение эффектов
    // и создает проблемы с циклическими перенаправлениями при авторизации
    const appElement = <App />;
    
    // Создаем корень React без задержки
    createRoot(root).render(appElement);
    console.log('React приложение успешно отрендерено');
  } catch (error) {
    console.error('Критическая ошибка при инициализации приложения:', error);
    
    // Показываем запасной UI в случае критической ошибки
    root.innerHTML = `
      <div style="padding: 20px; text-align: center; font-family: system-ui, -apple-system, sans-serif;">
        <h2>Приложение не удалось загрузить</h2>
        <p>Произошла ошибка при запуске приложения. Пожалуйста, обновите страницу.</p>
        <button onclick="window.location.reload()" style="padding: 8px 16px; background-color: #4CAF50; color: white; border: none; border-radius: 4px; cursor: pointer; margin-top: 20px;">
          Обновить страницу
        </button>
      </div>
    `;
  }
} else {
  console.error("КРИТИЧЕСКАЯ ОШИБКА: Корневой элемент #root не найден в DOM");
  
  // Создаем корневой элемент, если его нет
  const newRoot = document.createElement("div");
  newRoot.id = "root";
  document.body.appendChild(newRoot);
  
  try {
    const appElement = <App />;
    createRoot(newRoot).render(appElement);
    console.log('Создан новый корневой элемент и приложение отрендерено');
  } catch (error) {
    console.error('Ошибка при попытке создать новый корневой элемент:', error);
    
    // Показываем понятную ошибку для пользователя
    document.body.innerHTML = `
      <div style="padding: 20px; text-align: center; font-family: system-ui, -apple-system, sans-serif;">
        <h2>Приложение не удалось загрузить</h2>
        <p>Произошла критическая ошибка при запуске приложения.</p>
        <button onclick="window.location.reload()" style="padding: 8px 16px; background-color: #4CAF50; color: white; border: none; border-radius: 4px; cursor: pointer; margin-top: 20px;">
          Обновить страницу
        </button>
      </div>
    `;
  }
}
